import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Icon, Input } from "native-base";
import { IInputProps } from "native-base/lib/typescript/components/primitives/Input/types";
import React from "react";

type ComponentProps = IInputProps & {
  getRef?: (ref: any) => void;
};

const SearchInput = ({ getRef, ...props }: ComponentProps) => {
  return (
    <Input
      ref={getRef}
      h="48px"
      bgColor="white.50"
      borderRadius="2xl"
      placeholder="Digite o que você procura"
      fontSize="md"
      shadow="4"
      leftElement={
        <Icon as={<MaterialCommunityIcons name="magnify" />} size="lg" ml="2" color="primary.600" />
      }
      _focus={{
        bgColor: "white.50",
      }}
      {...props}
    />
  );
};

export default SearchInput;
